import React from "react";
import ReactDOM from "react-dom";
import { App } from "./components/app";
import "./styles.css";

ReactDOM.render(<App />, document.getElementById("root"));
